import ErrorBoundary from '@/ErrorBoundary';
import PageContainer from './PageContainer';
import PropTypes, { func, object } from 'prop-types';

const TabPanel = ({ menuItem }) => {
    const Component = menuItem.component;
    return menuItem ? (
        <>
            <div
                className="tabPageContainer w3-animate-right"
                style={{
                    ...(menuItem.selected
                        ? {
                              width: '100%',
                              height: ' calc(100vh - (var(--header-height) -var(--side-menu-tab-height)))',
                              overflow: 'auto',
                              paddingBottom: '30px',
                              paddingLeft: '30px',
                              background: '#9097a1',
                              borderRadius: '10px',
                          }
                        : { display: 'none' }),
                }}
            >
                <ErrorBoundary>
                    <PageContainer
                        menuName={menuItem.menuName}
                        menuId={menuItem.menuId}
                        helpYn={menuItem.helpYn}
                        menuNameList={menuItem.menuNameList}
                    >
                        {Component ? <Component /> : null}
                    </PageContainer>
                </ErrorBoundary>
            </div>
        </>
    ) : null;
};

TabPanel.propTypes = {
    menuItem: PropTypes.shape({
        component: PropTypes.oneOfType([func, object]),
        selected: PropTypes.bool,
        menuName: PropTypes.string,
        menuId: PropTypes.string,
        helpYn: PropTypes.string,
        menuNameList: PropTypes.string,
    }),
};

export default TabPanel;
